import onboardingLocale from './en.json'

const en = {
  onboarding: onboardingLocale,
}

export default en
